let suppressDepth = 0
let batchDepth = 0
let batchBaselineSerialized: string | null = null

export function isHistoryRecordingSuppressed(): boolean {
  return suppressDepth > 0
}

export function pushHistorySuppress(): void {
  suppressDepth += 1
}

export function popHistorySuppress(): void {
  suppressDepth = Math.max(0, suppressDepth - 1)
}

export function getHistoryBatchDepth(): number {
  return batchDepth
}

export function beginHistoryBatch(beforeSerialized: string): void {
  if (batchDepth === 0) {
    batchBaselineSerialized = beforeSerialized
  }
  batchDepth += 1
}

export function endHistoryBatch(): string | null {
  batchDepth = Math.max(0, batchDepth - 1)
  if (batchDepth > 0) return null
  const baseline = batchBaselineSerialized
  batchBaselineSerialized = null
  return baseline
}

export function clearHistoryBatchState(): void {
  batchDepth = 0
  batchBaselineSerialized = null
}
